import React from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import helpSchema from "./validations/helpSchema";

import Sallie from "../UIComponents/Sallie";
import LabelledInput from "../UIComponents/LabelledInput";
import SubmitButton from "../UIComponents/SubmitButton";

import { postHelp } from "../../api/helpReq";

const HelpPage = () => {
    const { t } = useTranslation();

    const history = useHistory();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitted, isSubmitSuccessful },
    } = useForm({
        resolver: yupResolver(helpSchema),
    });

    const onSubmit = async (data) => {
        try {
            await postHelp(data);
        } catch (err) {
            console.error("Help Page onSubmit Error:", err);
        }
    };

    let sallieText = t("helppage.default");
    if (isSubmitSuccessful) {
        sallieText = t("helppage.submitted");
    } else if (isSubmitted && !isSubmitSuccessful) {
        sallieText = t("helppage.error");
    }

    return (
        <div className="flex flex-col items-center mx-auto md:w-1/2">
            <Sallie text={sallieText} />

            {!isSubmitSuccessful && (
                <form onSubmit={handleSubmit(onSubmit)} className="m-3">
                    <LabelledInput
                        name="email"
                        type="email"
                        label={t("helppage.email")}
                        labelAs="h6"
                        inputRef={register}
                        errors={errors}
                        required
                        autoFocus
                    />
                    <LabelledInput
                        name="name"
                        label={t("helppage.name")}
                        labelAs="h6"
                        inputRef={register}
                        errors={errors}
                        required
                    />
                    <LabelledInput
                        name="ticket"
                        inputAs="textarea"
                        label={t("helppage.textarea_label")}
                        labelAs="h6"
                        extraInfo={t("helppage.textarea_info")}
                        inputRef={register}
                        errors={errors}
                        required
                    />

                    <div className="flex justify-between md:mt-2">
                        <SubmitButton
                            type="button"
                            onClick={history.goBack}
                            disabled={isSubmitting}
                        >
                            {t("helppage.go_back")}
                        </SubmitButton>
                        <SubmitButton type="submit" disabled={isSubmitting}>
                            {isSubmitting ? t("helppage.saving") : t("helppage.submit")}
                        </SubmitButton>
                    </div>
                </form>
            )}
        </div>
    );
};

export default HelpPage;